<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>學生登記表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>登記表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <!-- 登記表 -->
    <div class="col-md-12">
      <section class="panel" v-if="step==0">
        <treaty :key="$route.fullPath"></treaty>
      </section>
      <section class="panel" v-if="step==1">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">登記表</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">學 年 度：</label>
              <div class="col-sm-4">{{ schYearTerm }}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">系　　所：</label>
              <div class="col-sm-4">{{ item.deptName }}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">學　　號：</label>
              <div class="col-sm-4">{{ stuId }}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">班　　級：</label>
              <div class="col-sm-4">{{ item.dradeClass }}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">姓　　名：</label>
              <div class="col-sm-4">{{ item.studentName }}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">身分證/護照/居留證：</label>
              <div class="col-sm-4">{{ item.idno }}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">電　　話<span style="color: #ff0000">*</span>：</label>
              <div class="col-sm-4">
                <input type="text" style="width: 60%" v-model="form.phone" :disabled="!item.isSave && !isAdmin('tenancy')" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">戶籍地址：</label>
              <div class="col-sm-10">
                {{ item.regAddr }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">住宿方式<span style="color: #ff0000">*</span>：</label>
              <div class="col-sm-10">
                <select v-model="form.stayType" @change="stayTypeChange" :disabled="(!item.isSave || item.isApplyDormitory) && !isAdmin('tenancy')">
                  <option :value="null">--請選擇--</option>
                  <option value="與家人同住自宅">與家人同住自宅</option>
                  <option value="與家人一同租屋">與家人一同租屋</option>
                  <option value="寄宿親戚家">寄宿親戚家</option>
                  <option value="寄宿教會">寄宿教會</option>
                  <option value="寄宿朋友家">寄宿朋友家</option>
                  <option value="校外租屋">校外租屋</option>
                  <option value="學校宿舍">學校宿舍</option>
                  <option value="其他">其他</option>
                </select>
                <select v-model="form.stayTypeSub" v-if="form.stayType == '校外租屋'" :disabled="!item.isSave && !isAdmin('tenancy')">
                  <option :value="null">--請選擇--</option>
                  <option value="自租">自租</option>
                  <option value="與朋友合租">與朋友合租</option></select
                >　
                <input type="text" style="width: 40%" v-model="form.stayTypeSub" v-if="form.stayType == '其他'" :disabled="!item.isSave && !isAdmin('tenancy')" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="showStayPanel">
            <div class="group">
              <label class="col-sm-2">校外賃居地址<span style="color: #ff0000">*</span>：</label>
              <div class="col-sm-10">
                <select v-model="form.addrCityId" @change="addrCityChange" :disabled="!item.isSave && !isAdmin('tenancy')">
                  <option :value="null">--請選擇--</option>
                  <option v-for="(item, index) in cityList" :key="index" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
                <select v-model="form.addrAreaId" :disabled="!item.isSave && !isAdmin('tenancy')">
                  <option :value="null">--請選擇--</option>
                  <option v-for="(item, index) in addrAreaList" :key="index" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>　
                <input type="text" style="width: 40%" v-model="form.addr" :disabled="!item.isSave && !isAdmin('tenancy')" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="showStayPanel">
            <div class="group">
              <label class="col-sm-2">{{ landlordTitle }}姓名<span style="color: #ff0000">*</span>：</label>
              <div class="col-sm-10">
                <input type="text" style="width: 60%" v-model="form.landlordName" :disabled="!item.isSave && !isAdmin('tenancy')" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="form.stayType == '校外租屋'">
            <div class="group">
              <label class="col-sm-2">{{ landlordTitle }}職業<span style="color: #ff0000">*</span>：</label>
              <div class="col-sm-10">
                <input type="text" style="width: 60%" v-model="form.landlordJob" :disabled="!item.isSave && !isAdmin('tenancy')" />
              </div>
            </div>
          </div>
          <div class="form-group" v-if="showStayPanel">
            <div class="group">
              <label class="col-sm-2">{{ landlordTitle }}電話<span class="required">*</span>：</label>
              <div class="col-sm-10">
                <div class="radio-custom radio-primary">
                  <input id="landlordPhoneType_1" name="landlordPhoneType" type="radio" value="通訊軟體" v-model="form.landlordPhoneType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                  <label for="landlordPhoneType_1">通訊軟體　</label>
                </div>
                <div class="radio-custom radio-primary">
                  <input id="landlordPhoneType_2" name="landlordPhoneType" type="radio" value="聯絡電話" v-model="form.landlordPhoneType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                  <label for="landlordPhoneType_2">聯絡電話</label>　
                  <input type="text" style="width: 60%" v-model="form.landlordPhone" v-if="form.landlordPhoneType == '聯絡電話'" :disabled="!item.isSave && !isAdmin('tenancy')" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <div class="col-sm-2">備　　註</div>
              <label class="col-sm-10">
                <textarea rows="5" style="width: 100%" v-model="form.remark" :disabled="!item.isSave && !isAdmin('tenancy')"></textarea>
              </label>
            </div>
          </div>
          <div class="form-group" v-if="isAdmin('tenancy')">
            <label class="col-md-12 control-label">
              隱私權及個人資料保護政策宣告：{{ (customFormatter(form.crDate, "YYYY")-1911) + customFormatter(form.crDate, "年MM月DD日") }} 第{{ !!form.privacyTreatyVersion ? form.privacyTreatyVersion : "1.0" }}版
            </label>
          </div>
        </div>
      </section>
    </div>
    <!-- 租屋安全自我檢核表 -->
    <div class="col-md-12" v-show="form.stayType == '校外租屋' && step==1">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">租屋安全自我檢核表</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">消防安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_1_1" type="radio" :value="true" v-model="form.check.check_1_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_1_2" type="radio" :value="false" v-model="form.check.check_1_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_1_2">否</label>
                  </div>
                  　1.機車停車場保持距離 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_2_1" type="radio" :value="true" v-model="form.check.check_1_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_2_2" type="radio" :value="false" v-model="form.check.check_1_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_2_2">否</label>
                  </div>
                  　2.樓梯、走道出口通暢 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_3_1" type="radio" :value="true" v-model="form.check.check_1_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_3_2" type="radio" :value="false" v-model="form.check.check_1_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_3_2">否</label>
                  </div>
                  　3.逃生門（窗）備有鑰匙 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_4_1" type="radio" :value="true" v-model="form.check.check_1_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_4_2" type="radio" :value="false" v-model="form.check.check_1_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_4_2">否</label>
                  </div>
                  　4.逃生門（窗、梯）至少2處 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_5_1" type="radio" :value="true" v-model="form.check.check_1_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_5_2" type="radio" :value="false" v-model="form.check.check_1_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_5_2">否</label>
                  </div>
                  　5.逃生門開啟狀況良好 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_6_1" type="radio" :value="true" v-model="form.check.check_1_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_6_2" type="radio" :value="false" v-model="form.check.check_1_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_6_2">否</label>
                  </div>
                  　6.2F以上有緩降索或方便逃生 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_7_1" type="radio" :value="true" v-model="form.check.check_1_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_7_2" type="radio" :value="false" v-model="form.check.check_1_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_7_2">否</label>
                  </div>
                  　7.有緊急照明燈 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_8_1" type="radio" :value="true" v-model="form.check.check_1_8" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_8_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_8_2" type="radio" :value="false" v-model="form.check.check_1_8" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_8_2">否</label>
                  </div>
                  　8.有煙霧偵測器 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_9_1" type="radio" :value="true" v-model="form.check.check_1_9" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_9_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_9_2" type="radio" :value="false" v-model="form.check.check_1_9" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_9_2">否</label>
                  </div>
                  　9.滅火器足夠且無過期 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_10_1" type="radio" :value="true" v-model="form.check.check_1_10" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_10_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_10_2" type="radio" :value="false" v-model="form.check.check_1_10" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_10_2">否</label>
                  </div>
                  　10.有逃生指示 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_11_1" type="radio" :value="true" v-model="form.check.check_1_11" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_11_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_11_2" type="radio" :value="false" v-model="form.check.check_1_11" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_11_2">否</label>
                  </div>
                  　11.應設而設有灑水設備 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_12_1" type="radio" :value="true" v-model="form.check.check_1_12" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_12_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_12_2" type="radio" :value="false" v-model="form.check.check_1_12" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_1_12_2">否</label>
                  </div>
                  　12.防火巷道暢通 (3分)
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">電路安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_1_1" type="radio" :value="true" v-model="form.check.check_2_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_1_2" type="radio" :value="false" v-model="form.check.check_2_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_1_2">否</label>
                  </div>
                  　1.電源開關安全 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_2_1" type="radio" :value="true" v-model="form.check.check_2_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_2_2" type="radio" :value="false" v-model="form.check.check_2_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_2_2">否</label>
                  </div>
                  　2.電線無裸露老舊 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_3_1" type="radio" :value="true" v-model="form.check.check_2_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_3_2" type="radio" :value="false" v-model="form.check.check_2_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_3_2">否</label>
                  </div>
                  　3.電源線路整齊 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_4_1" type="radio" :value="true" v-model="form.check.check_2_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_4_2" type="radio" :value="false" v-model="form.check.check_2_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_4_2">否</label>
                  </div>
                  　4.插座數目充足（＞3處） (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_5_1" type="radio" :value="true" v-model="form.check.check_2_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_5_2" type="radio" :value="false" v-model="form.check.check_2_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_5_2">否</label>
                  </div>
                  　5.電源線路未綑綁避免過熱 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_6_1" type="radio" :value="true" v-model="form.check.check_2_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_6_2" type="radio" :value="false" v-model="form.check.check_2_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_2_6_2">否</label>
                  </div>
                  　6.插座插頭狀況良好 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">瓦斯安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_1_1" type="radio" :value="true" v-model="form.check.check_3_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_3_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_1_2" type="radio" :value="false" v-model="form.check.check_3_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_3_1_2">否</label>
                  </div>
                  　1.使用電熱水器（是以下免填） (8分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_2_1" type="radio" :value="true" v-model="form.check.check_3_2" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_2_2" type="radio" :value="false" v-model="form.check.check_3_2" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_2_2">否</label>
                  </div>
                  　2.管線良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_3_1" type="radio" :value="true" v-model="form.check.check_3_3" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_3_2" type="radio" :value="false" v-model="form.check.check_3_3" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_3_2">否</label>
                  </div>
                  　3.瓦斯熱水器置於室外 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_4_1" type="radio" :value="true" v-model="form.check.check_3_4" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_4_2" type="radio" :value="false" v-model="form.check.check_3_4" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_4_2">否</label>
                  </div>
                  　4.熱水器通風良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_5_1" type="radio" :value="true" v-model="form.check.check_3_5" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_5_2" type="radio" :value="false" v-model="form.check.check_3_5" :disabled="(!item.isSave && !isAdmin('tenancy')) || form.check.check_3_1 == true" />
                    <label for="check_3_5_2">否</label>
                  </div>
                  　5.瓦斯桶放置安全 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">結構安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_1_1" type="radio" :value="true" v-model="form.check.check_4_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_1_2" type="radio" :value="false" v-model="form.check.check_4_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_1_2">否</label>
                  </div>
                  　1.樑柱正常無傾斜 (1分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_2_1" type="radio" :value="true" v-model="form.check.check_4_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_2_2" type="radio" :value="false" v-model="form.check.check_4_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_2_2">否</label>
                  </div>
                  　2.牆壁無嚴重龜裂 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_3_1" type="radio" :value="true" v-model="form.check.check_4_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_3_2" type="radio" :value="false" v-model="form.check.check_4_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_3_2">否</label>
                  </div>
                  　3.無嚴重壁癌 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_4_1" type="radio" :value="true" v-model="form.check.check_4_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_4_2" type="radio" :value="false" v-model="form.check.check_4_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_4_2">否</label>
                  </div>
                  　4.天花板無嚴重漏水 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_5_1" type="radio" :value="true" v-model="form.check.check_4_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_5_2" type="radio" :value="false" v-model="form.check.check_4_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_5_2">否</label>
                  </div>
                  　5.門窗正常無變形 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_6_1" type="radio" :value="true" v-model="form.check.check_4_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_6_2" type="radio" :value="false" v-model="form.check.check_4_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_6_2">否</label>
                  </div>
                  　6.油漆無脫落 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_7_1" type="radio" :value="true" v-model="form.check.check_4_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_7_2" type="radio" :value="false" v-model="form.check.check_4_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_4_7_2">否</label>
                  </div>
                  　7.地板正常無凹陷 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">門戶安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_1_1" type="radio" :value="true" v-model="form.check.check_5_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_1_2" type="radio" :value="false" v-model="form.check.check_5_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_1_2">否</label>
                  </div>
                  　1.人員出入單純 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_2_1" type="radio" :value="true" v-model="form.check.check_5_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_2_2" type="radio" :value="false" v-model="form.check.check_5_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_2_2">否</label>
                  </div>
                  　2.有門禁或管理員 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_3_1" type="radio" :value="true" v-model="form.check.check_5_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_3_2" type="radio" :value="false" v-model="form.check.check_5_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_3_2">否</label>
                  </div>
                  　3.為單一出入口 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_4_1" type="radio" :value="true" v-model="form.check.check_5_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_4_2" type="radio" :value="false" v-model="form.check.check_5_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_4_2">否</label>
                  </div>
                  　4.使用刷卡（密碼）與上鎖 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_5_1" type="radio" :value="true" v-model="form.check.check_5_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_5_2" type="radio" :value="false" v-model="form.check.check_5_5" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_5_2">否</label>
                  </div>
                  　5.設有監視器 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_6_1" type="radio" :value="true" v-model="form.check.check_5_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_6_2" type="radio" :value="false" v-model="form.check.check_5_6" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_6_2">否</label>
                  </div>
                  　6.監視方位合宜 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_7_1" type="radio" :value="true" v-model="form.check.check_5_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_7_2" type="radio" :value="false" v-model="form.check.check_5_7" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_7_2">否</label>
                  </div>
                  　7.共同出入大門隨手關門 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_8_1" type="radio" :value="true" v-model="form.check.check_5_8" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_8_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_8_2" type="radio" :value="false" v-model="form.check.check_5_8" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_5_8_2">否</label>
                  </div>
                  　8.門鎖牢靠 (3分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">用水<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_1_1" type="radio" :value="true" v-model="form.check.check_6_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_1_2" type="radio" :value="false" v-model="form.check.check_6_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_1_2">否</label>
                  </div>
                  　1.有提供自來水 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_2_1" type="radio" :value="true" v-model="form.check.check_6_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_2_2" type="radio" :value="false" v-model="form.check.check_6_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_2_2">否</label>
                  </div>
                  　2.有提供過濾性飲水器 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_3_1" type="radio" :value="true" v-model="form.check.check_6_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_3_2" type="radio" :value="false" v-model="form.check.check_6_3" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_3_2">否</label>
                  </div>
                  　3.使用地下水 (3分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_4_1" type="radio" :value="true" v-model="form.check.check_6_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_4_2" type="radio" :value="false" v-model="form.check.check_6_4" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_6_4_2">否</label>
                  </div>
                  　4.有提供外購之安全飲用水 (1分)
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">鄰居<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_7_1_1" type="radio" :value="true" v-model="form.check.check_7_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_7_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_7_1_2" type="radio" :value="false" v-model="form.check.check_7_1" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_7_1_2">否</label>
                  </div>
                  　1.與房東互動良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_7_2_1" type="radio" :value="true" v-model="form.check.check_7_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_7_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_7_2_2" type="radio" :value="false" v-model="form.check.check_7_2" :disabled="!item.isSave && !isAdmin('tenancy')" />
                    <label for="check_7_2_2">否</label>
                  </div>
                  　2.無紛爭行為發生 (1分)
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">總分：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <label class="check-score">{{ checkScore }}</label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 租屋環境及設施 -->
    <div class="col-md-12" v-show="form.stayType == '校外租屋' && step==1">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">租屋環境及設施</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <label class="col-sm-3">類　　　型<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseType_1" type="radio" value="套房" v-model="form.houseType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseType_1">套房　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_2" type="radio" value="雅房" v-model="form.houseType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseType_2">雅房　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_3" type="radio" value="整層包租" v-model="form.houseType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseType_3">整層包租　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_4" type="radio" value="其他" v-model="form.houseType" :disabled="!item.isSave" />
                <label for="houseType_4">其他 <input type="text" id="houseTypeOtherText" v-model="form.houseTypeOtherText" v-if="form.houseType == '其他'" :disabled="!item.isSave && !isAdmin('tenancy')" /></label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">建　　　物<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseBuild_1" type="radio" value="公寓" v-model="form.houseBuild" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseBuild_1">公寓　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_2" type="radio" value="大廈" v-model="form.houseBuild" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseBuild_2">大廈　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_3" type="radio" value="頂樓加蓋" v-model="form.houseBuild" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseBuild_3">頂樓加蓋　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_4" type="radio" value="透天" v-model="form.houseBuild" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseBuild_4">透天</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">隔　　　間<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseRoom_1" type="radio" value="水泥" v-model="form.houseRoom" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRoom_1">水泥　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRoom_2" type="radio" value="木板" v-model="form.houseRoom" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRoom_2">木板　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRoom_3" type="radio" value="防火建材" v-model="form.houseRoom" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRoom_3">防火建材</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">結　　　構<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseStructure_1" type="radio" value="鋼筋混凝土(RC)" v-model="form.houseStructure" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseStructure_1"> 鋼筋混凝土(RC)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_2" type="radio" value="鋼骨鋼筋混凝土(SRC)" v-model="form.houseStructure" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseStructure_2">鋼骨鋼筋混凝土(SRC)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_3" type="radio" value="鋼骨(SS)" v-model="form.houseStructure" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseStructure_3">鋼骨(SS)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_4" type="radio" value="木造" v-model="form.houseStructure" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseStructure_4">木造　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_5" type="radio" value="鐵皮屋" v-model="form.houseStructure" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseStructure_5">鐵皮屋</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">樓　　　層<span class="required">*</span></label>
            <div class="col-sm-9">
              <label>
                總樓層
                <input type="number" id="houseTotalFloor" min="0" size="5" v-model="form.houseTotalFloor" :disabled="!item.isSave && !isAdmin('tenancy')" />
                樓之第
                <input type="number" min="0" size="5" v-model="form.houseFloor" :disabled="!item.isSave && !isAdmin('tenancy')" />
                樓
              </label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">屋　　　齡</label>
            <div class="col-sm-9">
              <label>
                大　約
                <input type="number" id="houseAge" min="0" size="5" v-model="form.houseAge" :disabled="!item.isSave && !isAdmin('tenancy')" />
                年
              </label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">坪　　　數<span class="required">*</span></label>
            <div class="col-sm-9">
              <label>
                使用約
                <input type="number" id="houseFootage" min="0" size="5" v-model="form.houseFootage" :disabled="!item.isSave && !isAdmin('tenancy')" />
                坪
              </label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">租　　　金<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseRentType_1" type="radio" value="月繳" v-model="form.houseRentType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRentType_1">月繳　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRentType_2" type="radio" value="期繳" v-model="form.houseRentType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRentType_2">期繳　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRentType_3" type="radio" value="季繳" v-model="form.houseRentType" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseRentType_3">季繳</label>
              </div>
              <input type="number" size="10" v-model="form.houseRent" :disabled="!item.isSave && !isAdmin('tenancy')" />元
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">押　　　金<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasDeposit_1" type="radio" :value="false" v-model="houseHasDeposit" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasDeposit_1">免付　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasDeposit_2" type="radio" :value="true" v-model="houseHasDeposit" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasDeposit_2">
                  需繳
                  <input type="number" id="houseDeposit" size="10" v-model="form.houseDeposit" :disabled="(!item.isSave && !isAdmin('tenancy')) || !houseHasDeposit" />
                  元
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">水　　　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasWaterBill_1" type="radio" :value="false" v-model="houseHasWaterBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasWaterBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasWaterBill_2" type="radio" :value="true" v-model="houseHasWaterBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasWaterBill_2">
                  另付
                  <input type="number" id="houseWaterBill" size="10" v-model="form.houseWaterBill" :disabled="(!item.isSave && !isAdmin('tenancy')) || !houseHasWaterBill" />
                  元
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">電　　　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasElecBill_1" type="radio" :value="false" v-model="houseHasElecBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasElecBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasElecBill_2" type="radio" :value="true" v-model="houseHasElecBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasElecBill_2">
                  另付
                  <input type="number" id="houseElecBill" size="10" v-model="form.houseElecBill" :disabled="(!item.isSave && !isAdmin('tenancy')) || !houseHasElecBill" />
                  元
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">瓦　斯　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_1" type="radio" value="內含" v-model="houseHasGasBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasGasBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_2" type="radio" value="另付" v-model="houseHasGasBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasGasBill_2">
                  另付
                  <input type="number" id="houseGasBill" size="10" v-model="form.houseGasBill" :disabled="(!item.isSave && !isAdmin('tenancy')) || houseHasGasBill != '另付'" />
                  元　
                </label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_3" type="radio" value="無" v-model="houseHasGasBill" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasGasBill_3">無</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">管　理　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_1" type="radio" value="內含" v-model="houseHasHoa" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasHoa_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_2" type="radio" value="另付" v-model="houseHasHoa" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasHoa_2">
                  另付
                  <input type="number" id="houseHoa" size="10" v-model="form.houseHoa" :disabled="(!item.isSave && !isAdmin('tenancy')) || houseHasHoa != '另付'" />
                  元　
                </label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_3" type="radio" value="無" v-model="houseHasHoa" :disabled="!item.isSave && !isAdmin('tenancy')" />
                <label for="houseHasHoa_3">無</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3">其 他 費 用</label>
            <div class="col-sm-9">
              <label><input type="text" id="houseOtherCost" style="width: 180%" v-model="form.houseOtherCost" :disabled="!item.isSave && !isAdmin('tenancy')" /> </label>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div class="col-md-4 col-md-offset-4" v-if="step==1">
      <table width="100%" style="margin: 6px; text-align: center">
        <br />
        <tr>
          <td>
            <a v-if="item.isSave" href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color: #666; border-color: #999; color: #fff">重　　填</a>　
          </td>
          <td >
            <a v-if="item.isSave || isAdmin('tenancy')" href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color: #337ab7; border-color: #2e6da4; color: #fff">儲　　存</a>
          </td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import treaty from "@/bursary/views/tenancy-register/treaty";

export default {
  components: {
    treaty
  },
  data() {
    return {
      item: {},
      cityList: [],
      areaList: [],
      regAddrAreaList: [],
      addrAreaList: [],
      houseHasDeposit: null,
      houseHasWaterBill: null,
      houseHasElecBill: null,
      houseHasGasBill: null,
      houseHasHoa: null,
      form: {
        schYearTerm: null,
        studentId: null,
        phone: null,
        stayType: null,
        stayTypeSub: null,
        addrCityId: null,
        addrAreaId: null,
        addr: null,
        landlordName: null,
        landlordJob: null,
        landlordPhoneType: null,
        landlordPhone: "",
        remark: "",
        check: {
          check_1_1: null,
          check_1_2: null,
          check_1_3: null,
          check_1_4: null,
          check_1_5: null,
          check_1_6: null,
          check_1_7: null,
          check_1_8: null,
          check_1_9: null,
          check_1_10: null,
          check_1_11: null,
          check_1_12: null,
          check_2_1: null,
          check_2_2: null,
          check_2_3: null,
          check_2_4: null,
          check_2_5: null,
          check_2_6: null,
          check_3_1: null,
          check_3_2: null,
          check_3_3: null,
          check_3_4: null,
          check_3_5: null,
          check_4_1: null,
          check_4_2: null,
          check_4_3: null,
          check_4_4: null,
          check_4_5: null,
          check_4_6: null,
          check_4_7: null,
          check_5_1: null,
          check_5_2: null,
          check_5_3: null,
          check_5_4: null,
          check_5_5: null,
          check_5_6: null,
          check_5_7: null,
          check_5_8: null,
          check_6_1: null,
          check_6_2: null,
          check_6_3: null,
          check_6_4: null,
          check_7_1: null,
          check_7_2: null,
        },
        houseType: null,
        houseTypeOtherText: null,
        houseBuild: null,
        houseRoom: null,
        houseStructure: null,
        houseTotalFloor: null,
        houseFloor: null,
        houseAge: null,
        houseFootage: null,
        houseRentType: null,
        houseRent: null,
        houseDeposit: null,
        houseWaterBill: null,
        houseElecBill: null,
        houseGasBill: null,
        houseHoa: null,
        houseOtherCost: null,
        houseNoGasBill: null,
        houseNoHoa: null,
      },
      checkListIsOk: true,
      checkScore: 0,
      step: -1
    };
  },
  computed: {
    schYearTerm() {
      return this.$route.params.year.replace("|", "/");
    },
    stuId() {
      return this.$route.params.id;
    },
    showStayPanel() {
      switch (this.form.stayType) {
        case "寄宿教會":
        case "寄宿朋友家":
        case "校外租屋":
        case "其他":
          return true;
        default:
          return false;
      }
    },
    landlordTitle() {
      switch (this.form.stayType) {
        case "寄宿教會":
          return "教會負責人";
        case "寄宿朋友家":
          return "朋友";
        default:
          return "房東";
      }
    },
    formCheckList() {
      return this.form.check;
    },
  },
  mounted() {
    this.form.schYearTerm = this.schYearTerm.replace("/", "");
    this.form.studentId = this.stuId;
    this.$http.get("/api/shared/city-list").then((a) => {
      this.cityList = a.body;
      this.$http.get("/api/shared/area-list").then((a) => {
        this.areaList = a.body;
        this.load();
      });
    });
  },
  methods: {
    stayTypeChange() {
      if (this.form.stayType == "校外租屋" || this.form.stayType == "其他") {
        this.form.stayTypeSub = null;
      }
      this.form.landlordName = null;
    },
    regAddrCityChange() {
      if (this.form.regAddrCityId) {
        this.regAddrAreaList = this.areaList.filter((item) => {
          return item.cityId == this.form.regAddrCityId;
        });
      } else {
        this.regAddrAreaList = [];
      }
      this.form.regAddrAreaId = null;
    },
    addrCityChange() {
      if (this.form.addrCityId) {
        this.addrAreaList = this.areaList.filter((item) => {
          return item.cityId == this.form.addrCityId;
        });
      } else {
        this.addrAreaList = [];
      }
      this.form.addrAreaId = null;
    },
    load() {
      this.$http
        .get("/api/tenancyRegister/edit", {
          params: {
            schYearTerm: this.schYearTerm.replace("/", ""),
            stuId: this.stuId,
          },
        })
        .then((a) => {
          this.item = a.body;
          this.form.phone = this.item.phone;
          this.form.regAddrCityId = this.item.regAddrCityId;
          if (this.form.regAddrCityId) this.regAddrCityChange();
          this.form.regAddrAreaId = this.item.regAddrAreaId;
          this.form.regAddr = this.item.regAddr;
          this.form.stayType = this.item.isApplyDormitory ? '學校宿舍' : this.item.stayType;
          this.form.stayTypeSub = this.item.stayTypeSub;
          this.form.addrCityId = this.item.addrCityId;
          if (this.form.addrCityId) this.addrCityChange();
          this.form.addrAreaId = this.item.addrAreaId;
          this.form.addr = this.item.addr;
          this.form.landlordName = this.item.landlordName;
          this.form.landlordJob = this.item.landlordJob;
          this.form.landlordPhoneType = this.item.landlordPhoneType;
          this.form.landlordPhone = this.item.landlordPhone;
          this.form.remark = this.item.remark || "";
          this.form.check.check_1_1 = this.item.check_1_1;
          this.form.check.check_1_2 = this.item.check_1_2;
          this.form.check.check_1_3 = this.item.check_1_3;
          this.form.check.check_1_4 = this.item.check_1_4;
          this.form.check.check_1_5 = this.item.check_1_5;
          this.form.check.check_1_6 = this.item.check_1_6;
          this.form.check.check_1_7 = this.item.check_1_7;
          this.form.check.check_1_8 = this.item.check_1_8;
          this.form.check.check_1_9 = this.item.check_1_9;
          this.form.check.check_1_10 = this.item.check_1_10;
          this.form.check.check_1_11 = this.item.check_1_11;
          this.form.check.check_1_12 = this.item.check_1_12;
          this.form.check.check_2_1 = this.item.check_2_1;
          this.form.check.check_2_2 = this.item.check_2_2;
          this.form.check.check_2_3 = this.item.check_2_3;
          this.form.check.check_2_4 = this.item.check_2_4;
          this.form.check.check_2_5 = this.item.check_2_5;
          this.form.check.check_2_6 = this.item.check_2_6;
          this.form.check.check_3_1 = this.item.check_3_1;
          this.form.check.check_3_2 = this.item.check_3_2;
          this.form.check.check_3_3 = this.item.check_3_3;
          this.form.check.check_3_4 = this.item.check_3_4;
          this.form.check.check_3_5 = this.item.check_3_5;
          this.form.check.check_4_1 = this.item.check_4_1;
          this.form.check.check_4_2 = this.item.check_4_2;
          this.form.check.check_4_3 = this.item.check_4_3;
          this.form.check.check_4_4 = this.item.check_4_4;
          this.form.check.check_4_5 = this.item.check_4_5;
          this.form.check.check_4_6 = this.item.check_4_6;
          this.form.check.check_4_7 = this.item.check_4_7;
          this.form.check.check_5_1 = this.item.check_5_1;
          this.form.check.check_5_2 = this.item.check_5_2;
          this.form.check.check_5_3 = this.item.check_5_3;
          this.form.check.check_5_4 = this.item.check_5_4;
          this.form.check.check_5_5 = this.item.check_5_5;
          this.form.check.check_5_6 = this.item.check_5_6;
          this.form.check.check_5_7 = this.item.check_5_7;
          this.form.check.check_5_8 = this.item.check_5_8;
          this.form.check.check_6_1 = this.item.check_6_1;
          this.form.check.check_6_2 = this.item.check_6_2;
          this.form.check.check_6_3 = this.item.check_6_3;
          this.form.check.check_6_4 = this.item.check_6_4;
          this.form.check.check_7_1 = this.item.check_7_1;
          this.form.check.check_7_2 = this.item.check_7_2;
          this.form.houseType = this.item.houseType;
          this.form.houseTypeOtherText = this.item.houseTypeOtherText;
          this.form.houseBuild = this.item.houseBuild;
          this.form.houseRoom = this.item.houseRoom;
          this.form.houseStructure = this.item.houseStructure;
          this.form.houseTotalFloor = this.item.houseTotalFloor;
          this.form.houseFloor = this.item.houseFloor;
          this.form.houseAge = this.item.houseAge;
          this.form.houseFootage = this.item.houseFootage;
          this.form.houseRentType = this.item.houseRentType;
          this.form.houseRent = this.item.houseRent;
          this.form.crDate = this.item.crDate;
          this.form.privacyTreatyVersion = this.item.privacyTreatyVersion;
          this.houseHasDeposit = this.item.houseDeposit != null;
          this.houseHasWaterBill = this.item.houseWaterBill != null;
          this.houseHasElecBill = this.item.houseElecBill != null;
          this.houseHasGasBill = this.item.houseNoGasBill ? "無" : this.item.houseGasBill == null ? "內含" : "另付";
          this.houseHasHoa = this.item.houseNoHoa ? "無" : this.item.houseHoa == null ? "內含" : "另付";
          this.step = this.item.id ? 1 : 0;
          this.form.houseDeposit = this.item.houseDeposit;
          this.form.houseWaterBill = this.item.houseWaterBill;
          this.form.houseElecBill = this.item.houseElecBill;
          this.form.houseGasBill = this.item.houseGasBill;
          this.form.houseHoa = this.item.houseHoa;
          this.form.houseOtherCost = this.item.houseOtherCost;
          this.clacCheckScore();
        });
    },
    formClear() {
      this.load();
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/tenancyRegister/edit/", this.form).then((a) => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/tenancy-register");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    checkForm() {
      let focus = true;
      let msg = "";
      if (!this.form.phone) msg += "『電話』、";
      if (!this.form.stayType || ((this.form.stayType == "校外租屋" || this.form.stayType == "其他") && !this.form.stayTypeSub)) msg += "『住宿方式』、";
      if (this.form.stayType == "校外租屋" || this.form.stayType == "寄宿教會" || this.form.stayType == "寄宿朋友家" || this.form.stayType == "其他") {
        if (!this.form.addrCityId || !this.form.addrAreaId || !this.form.addr) msg += "『校外賃居地址』、";
        if (!this.form.landlordName) msg += "『" + this.landlordTitle + "姓名』、";
        if (!this.form.landlordPhoneType || (this.form.landlordPhoneType == "聯絡電話" && !this.form.landlordPhone)) {
          msg += "『" + this.landlordTitle + "電話』、";
        }

        if (this.form.stayType == "校外租屋" && !this.form.landlordJob) msg += "『" + this.landlordTitle + "職業』、";
      }
      if (this.form.stayType == "校外租屋") {
        if (!this.form.houseType) {
          msg += "『租屋環境及設施-類型』、";
          if (focus) {
            $("#houseType_1").focus();
            focus = false;
          }
        }
        if (this.form.houseType == "其他" && !this.form.houseTypeOtherText) {
          msg += "『『租屋環境及設施-類型-其他-文字描述』、";
          if (focus) {
            $("#houseTypeOtherText").focus();
            focus = false;
          }
        }
        if (!this.form.houseBuild) {
          msg += "『租屋環境及設施-建物』、";
          if (focus) {
            $("#houseBuild_1").focus();
            focus = false;
          }
        }
        if (!this.form.houseRoom) {
          msg += "『租屋環境及設施-隔間』、";
          if (focus) {
            $("#houseRoom_1").focus();
            focus = false;
          }
        }
        if (!this.form.houseStructure) {
          msg += "『租屋環境及設施-結構』、";
          if (focus) {
            $("#houseStructure_1").focus();
            focus = false;
          }
        }
        if (!this.form.houseTotalFloor || !this.form.houseFloor) {
          msg += "『租屋環境及設施-樓層』、";
          if (focus) {
            $("#houseTotalFloor").focus();
            focus = false;
          }
        }
        // if (!this.form.houseAge) {
        //   msg += "『租屋環境及設施-屋齡』、";
        //   if (focus) { $("#houseAge").focus(); focus = false; }
        // }
        if (!this.form.houseFootage) {
          msg += "『租屋環境及設施-坪數』、";
          if (focus) {
            $("#houseFootage").focus();
            focus = false;
          }
        }
        if (!this.form.houseRentType || !this.form.houseRent) {
          msg += "『租屋環境及設施-租金』、";
          if (focus) {
            $("#houseRentType_1").focus();
            focus = false;
          }
        }
        if (this.houseHasDeposit == true && !this.form.houseDeposit) {
          msg += "『租屋環境及設施-押金』、";
          if (focus) {
            $("#houseDeposit").focus();
            focus = false;
          }
        }
        if (this.houseHasWaterBill == null || (this.houseHasWaterBill == true && !this.form.houseWaterBill)) {
          msg += "『租屋環境及設施-水費』、";
          if (focus) {
            $("#houseHasWaterBill_1").focus();
            focus = false;
          }
        }
        if (this.houseHasElecBill == null || (this.houseHasElecBill == true && !this.form.houseElecBill)) {
          msg += "『租屋環境及設施-電費』、";
          if (focus) {
            $("#houseHasElecBill_1").focus();
            focus = false;
          }
        }
        if (this.houseHasGasBill == null || (this.houseHasGasBill == "另付" && !this.form.houseGasBill)) {
          msg += "『租屋環境及設施-瓦斯費』、";
          if (focus) {
            $("#houseHasGasBill_1").focus();
            focus = false;
          }
        }
        if (this.houseHasHoa == null || (this.houseHasHoa == "另付" && !this.form.houseHoa)) {
          msg += "『租屋環境及設施-管理費』、";
          if (focus) {
            $("#houseHasHoa_1").focus();
            focus = false;
          }
        }
      }
      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未填寫");
        return false;
      }
      if (this.form.remark.replace("\n", "").length > 100) {
        alert("『備註』欄位輸入不可超過100字");
        return false;
      }
      if (this.form.landlordPhone && this.form.landlordPhoneType == "聯絡電話") {
        if (this.form.landlordPhone.length > 20) {
          alert("『聯絡電話』長度過長");
          return false;
        }
      }
      if (this.form.stayType == "校外租屋") {
        if (this.checkListIsOk !== true) {
          alert("『租屋安全自我檢核表』尚未選取完整，請檢查確認");
          return false;
        }
        if (this.form.houseType != "其他") this.form.houseTypeOtherText = null;
        if (this.houseHasDeposit == false) this.form.houseDeposit = null;
        if (this.houseHasWaterBill == false) this.form.houseWaterBill = null;
        if (this.houseHasElecBill == false) this.form.houseElecBill = null;
        if (this.houseHasGasBill != "另付") this.form.houseGasBill = null;
        if (this.houseHasHoa != "另付") this.form.houseHoa = null;
        this.form.houseNoGasBill = (this.houseHasGasBill == "無");
        this.form.houseNoHoa = (this.houseHasHoa == "無");
      } else {
          this.form.check.check_1_1 = null;
          this.form.check.check_1_2 = null;
          this.form.check.check_1_3 = null;
          this.form.check.check_1_4 = null;
          this.form.check.check_1_5 = null;
          this.form.check.check_1_6 = null;
          this.form.check.check_1_7 = null;
          this.form.check.check_1_8 = null;
          this.form.check.check_1_9 = null;
          this.form.check.check_1_10 = null;
          this.form.check.check_1_11 = null;
          this.form.check.check_1_12 = null;
          this.form.check.check_2_1 = null;
          this.form.check.check_2_2 = null;
          this.form.check.check_2_3 = null;
          this.form.check.check_2_4 = null;
          this.form.check.check_2_5 = null;
          this.form.check.check_2_6 = null;
          this.form.check.check_3_1 = null;
          this.form.check.check_3_2 = null;
          this.form.check.check_3_3 = null;
          this.form.check.check_3_4 = null;
          this.form.check.check_3_5 = null;
          this.form.check.check_4_1 = null;
          this.form.check.check_4_2 = null;
          this.form.check.check_4_3 = null;
          this.form.check.check_4_4 = null;
          this.form.check.check_4_5 = null;
          this.form.check.check_4_6 = null;
          this.form.check.check_4_7 = null;
          this.form.check.check_5_1 = null;
          this.form.check.check_5_2 = null;
          this.form.check.check_5_3 = null;
          this.form.check.check_5_4 = null;
          this.form.check.check_5_5 = null;
          this.form.check.check_5_6 = null;
          this.form.check.check_5_7 = null;
          this.form.check.check_5_8 = null;
          this.form.check.check_6_1 = null;
          this.form.check.check_6_2 = null;
          this.form.check.check_6_3 = null;
          this.form.check.check_6_4 = null;
          this.form.check.check_7_1 = null;
          this.form.check.check_7_2 = null;
          this.form.houseType = null;
          this.form.houseTypeOtherText = null;
          this.form.houseBuild = null;
          this.form.houseRoom = null;
          this.form.houseStructure = null;
          this.form.houseTotalFloor = null;
          this.form.houseFloor = null;
          this.form.houseAge = null;
          this.form.houseFootage = null;
          this.form.houseRentType = null;
          this.form.houseRent = null;
          this.form.houseDeposit = null;
          this.form.houseWaterBill = null;
          this.form.houseElecBill = null;
          this.form.houseGasBill = null;
          this.form.houseHoa = null;
          this.form.houseOtherCost = null;
          this.form.houseNoGasBill = null;
          this.form.houseNoHoa = null;
      }

      return true;
    },
    clacCheckScore() {
        let checkScore = 0;
        let check_3_1 = false;
        let checkListIsOk = true;
        for (const [key, value] of Object.entries(this.formCheckList)) {
          if (value === undefined || value === null) {
            if (key !== "check_3_2" && key !== "check_3_3" && key !== "check_3_4" && key !== "check_3_5") checkListIsOk = false;
            if (!(check_3_1 === true && (key === "check_3_2" || key === "check_3_3" || key === "check_3_4" || key === "check_3_5"))) checkListIsOk = false;
          }
          if (key === "check_6_3") {
            if (value !== false) continue;
          } else if (value !== true) continue;
          switch (key) {
            case "check_1_2":
            case "check_1_4":
            case "check_1_7":
            case "check_1_8":
            case "check_1_9":
            case "check_1_10":
            case "check_1_12":
            case "check_5_8":
            case "check_6_3":
              checkScore += 3;
              break;
            case "check_4_1":
            case "check_6_4":
            case "check_7_2":
              checkScore++;
              break;
            case "check_3_1":
              check_3_1 = true;
              this.form.check.check_3_2 = null;
              this.form.check.check_3_3 = null;
              this.form.check.check_3_4 = null;
              this.form.check.check_3_5 = null;
              checkScore += 8;
              break;
            case "check_3_2":
            case "check_3_3":
            case "check_3_4":
            case "check_3_5":
              if (check_3_1 === true) break;
            default:
              checkScore += 2;
          }
        }
        this.checkListIsOk = checkListIsOk;
        this.checkScore = checkScore;
    }
  },
  watch: {
    formCheckList: {
      handler(val) {
        this.clacCheckScore();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
div.radio-custom {
  display: inline-block;
}
label.check-score {
  font-weight: bold;
  color: red;
  margin-left: 10px;
}
</style>
